import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useFormPopup } from "@/components/FormPopupContext";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { setOpen: setFormOpen } = useFormPopup();

  const links = [
    { label: "Beneficios", href: "#beneficios" },
    { label: "Como funciona", href: "#como-funciona" },
    { label: "Creditos", href: "#creditos" },
    { label: "Simular", href: "#simulador" },
  ];

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200/60 saturate-150"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 flex items-center justify-between h-16">
        <a href="/" className="flex items-center gap-2" data-testid="navbar-logo">
          <div className="w-8 h-8 rounded-xl bg-emerald-500 flex items-center justify-center">
            <Shield className="w-4 h-4 text-white" />
          </div>
          <span className="font-semibold text-lg text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
            CrediAcceso
          </span>
        </a>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors duration-200"
              data-testid={`nav-link-${l.href.slice(1)}`}
            >
              {l.label}
            </a>
          ))}
          <Button
            data-testid="nav-cta-simular"
            onClick={() => setFormOpen(true)}
            className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl px-5 h-9 text-sm font-medium"
          >
            Simular credito
          </Button>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          data-testid="navbar-mobile-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-white border-t border-slate-200/60 px-6 py-4 space-y-3" data-testid="navbar-mobile-menu">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-sm font-medium text-slate-600 hover:text-slate-900 py-2"
            >
              {l.label}
            </a>
          ))}
          <Button
            onClick={() => { setOpen(false); setFormOpen(true); }}
            className="w-full bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl h-10 text-sm font-medium"
          >
            Simular credito
          </Button>
        </div>
      )}
    </nav>
  );
}
